document.addEventListener('turbo:load', function(e) {
  
  /* --------------------------------------------------
                Create Map
  -------------------------------------------------- */
  pgJobsViewMap = function(){
    const googleMaps = document.getElementById('pages-jobs-view-map');
    if (!googleMaps) return;

    // Load jobs data from data attribute
    let jobsData;
    try {
      jobsData = JSON.parse(googleMaps.dataset.jobs || '[]');
    } catch (e) {
      console.warn('Failed to parse jobs data');
      return;
    }

    // Get first job with location
    const firstJobWithLocation = jobsData.find(job => job.location_lat && job.location_lng);

    // Create map
    const map = new google.maps.Map(googleMaps, { 
      zoom: 7, 
      mapTypeControl: false,
      streetViewControl: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      center: { 
        lat: parseFloat(firstJobWithLocation.location_lat), 
        lng: parseFloat(firstJobWithLocation.location_lng) 
      },
      mapId: 'biddy_jobs_map'
    });
    const mapInfoWindow = new google.maps.InfoWindow;
    const mapMarkers = [];

    // Loop through jobs and create markers
    for (const [index, job] of jobsData.entries()) {
      if (job.location_lat && job.location_lng) {
        const markerOptions = {
          position: { 
            lat: parseFloat(job.location_lat), 
            lng: parseFloat(job.location_lng)
          },
          map: map,
          title: job.name
        };

        const pinElement = new google.maps.marker.PinElement({
          scale: 1,
          background: '#000000',
          borderColor: '#FFFFFF',
          glyphColor: '#FFFFFF',
          glyph: '●'
        });
        markerOptions.content = pinElement.element;

        // Create the marker
        const mapMarker = new google.maps.marker.AdvancedMarkerElement(markerOptions);
        mapMarkers.push(mapMarker);

        // Handle click events
        const clickHandler = function() {
          mapInfoWindow.setContent(
            '<div class="flex flex-col gap-1">' +
              '<div>' +
                '<div class="text-sm font-semibold">' + job.name + '</div>' +
                '<div class="text-xs text-gray-500 font-medium">' + job.location + '</div>' +
              '</div>' +
              '<a href="/pages/jobs/' + job.id + '/view/show" class="block text-xs font-semibold focus:outline-none">View Project &rarr;</a>' +
            '</div>'
          );
          mapInfoWindow.setOptions({ maxWidth: 240 });
          mapInfoWindow.open(map, this);
        };

        // Add event listeners
        mapMarker.addEventListener('gmp-click', clickHandler);
        mapMarker.addEventListener('mouseenter', clickHandler);

        // Handle mouse enter events
        const jobCard = document.querySelector('[data-js="job-card"][data-index="' + index + '"]');
        if (jobCard) {
          jobCard.addEventListener('mouseenter', (e) => {
            mapInfoWindow.close();
            mapMarker.dispatchEvent(new Event('gmp-click'));
          });
        }
      }
    }
  }

  /* --------------------------------------------------
                Load Google Maps API
  -------------------------------------------------- */
  pgJobsViewLoadGoogleMapsAPI = function() {
    const mapContainer = document.getElementById('pages-jobs-view-map');
    if (!mapContainer) return;

    // Get API key
    const apiKey = mapContainer.dataset.apiKey;

    // Load Google Maps API
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker&v=beta`;
    script.async = true;
    script.defer = true;
    
    script.onload = function() {
      pgJobsViewMap();
    };
    
    // Handle error
    script.onerror = function() {
      console.error('Failed to load Google Maps API');
      if (mapContainer) {
        mapContainer.innerHTML = '<div class="flex items-center justify-center h-full text-gray-500">Failed to load map service</div>';
      }
    };
    
    // Append script to head
    document.head.appendChild(script);
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pgJobsViewLoadGoogleMapsAPI();
});